const Product = () => {
  return <div>Here is product page</div>;
};

export default Product;
